import { Link } from "react-router-dom";
import { FaMinus, FaPlus, FaTrash } from "react-icons/fa";
import { useQuote } from "../../context/QuoteContext";
import EmptyState from "../EmptyState/EmptyState";
import { stripHtml } from "../../utils/richText";

export default function QuoteCart() {
  const { items, increase, decrease, remove, updateNote } = useQuote();

  if (!items.length) {
    return <EmptyState title="Your quote cart is empty" description="Add products from the catalogue to prepare a quotation request." />;
  }

  return (
    <div className="grid gap-4">
      {items.map((item) => (
        <article key={item.quoteKey || item.id} className="grid gap-4 rounded-xl border border-line bg-white p-4 shadow-soft sm:grid-cols-[140px_1fr]">
          <Link to={`/products/${item.id}`} className="block overflow-hidden rounded-xl">
            <img src={item.image} alt={stripHtml(item.name)} className="h-36 w-full object-contain transition hover:scale-105" />
          </Link>
          <div>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
              <div>
                <p className="text-sm font-bold text-primary">{item.brand}</p>
                <h3 className="text-xl font-semibold text-dark">{stripHtml(item.name)}</h3>
                {item.selectedVariant?.label ? (
                  <p className="mt-1 text-sm font-semibold text-dark">
                    {item.optionGroupName || "Option"}: {item.selectedVariant.label}
                  </p>
                ) : null}
                <p className="mt-1 text-sm font-semibold text-slate-500">MOQ: {item.moq}</p>
              </div>
              <button onClick={() => remove(item.quoteKey || item.id)} className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-line text-danger transition hover:bg-red-50" aria-label={`Remove ${stripHtml(item.name)}`}>
                <FaTrash />
              </button>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-3">
              <button onClick={() => decrease(item.quoteKey || item.id)} className="grid h-10 w-10 place-items-center rounded-xl border border-line text-dark hover:border-primary hover:text-primary" aria-label="Decrease quantity"><FaMinus /></button>
              <span className="grid h-10 min-w-14 place-items-center rounded-xl bg-slate-50 px-4 text-sm font-semibold text-dark">{item.quantity} {item.unit || "pcs"}</span>
              <button onClick={() => increase(item.quoteKey || item.id)} className="grid h-10 w-10 place-items-center rounded-xl border border-line text-dark hover:border-primary hover:text-primary" aria-label="Increase quantity"><FaPlus /></button>
              <span className="text-sm font-semibold text-slate-500">Example: Need 500 cells, 16S BMS, XT connector, dealer pricing or bulk supply.</span>
            </div>
            <label className="mt-4 block">
              <span className="mb-2 block text-sm font-bold text-dark">Product Notes</span>
              <textarea value={item.note} onChange={(event) => updateNote(item.quoteKey || item.id, event.target.value)} placeholder="Need 500 cells, 16S BMS, fast dispatch, dealer pricing..." className="min-h-24 w-full rounded-xl border border-line px-4 py-3 text-sm focus:border-primary focus:ring-2 focus:ring-emerald-100" />
            </label>
          </div>
        </article>
      ))}
    </div>
  );
}
